import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { initialStatus, loadingStatus } from '../../../../core/models/request-status.model';
import { Router } from '@angular/router';
import { ReturnStatusRequest } from '../core/return.model';
import { ReturnService } from '../core/return.service';
import { Order, OrderFacade } from '@spartacus/order/root';
import { TOASTER_TYPE } from '../../../../components/toaster/toaster.model';
import { ToasterService } from '../../../../components/toaster/toaster.service';
import { ExcelDownloadService } from '../../../../core/services/excelDownload.service';

@Component({
  selector: 'app-return-details',
  templateUrl: './return-details.component.html',
  styleUrl: './return-details.component.scss',
  standalone: false,
})
export class ReturnDetailsComponent implements OnInit, OnDestroy {
  returnRequest$ = new BehaviorSubject<ReturnStatusRequest>({
    ...initialStatus,
  });

  order$: Observable<Order | undefined> = this.orderFacade.getOrderDetails();

  uid: any;
  subscription = new Subscription();
  constructor(
    protected orderFacade: OrderFacade,
    private router: Router,
    private returnsService: ReturnService,
    private toasterService: ToasterService,
    private excelDownloadService: ExcelDownloadService,
  ) {}

  ngOnInit(): void {
    this.uid = this.router.url.split('/').pop();
    this.getOrder();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getOrder(): void {
    this.returnRequest$.next({ ...loadingStatus });
    this.subscription.add(
      this.returnsService
        .getOrder({ uid: decodeURIComponent(this.uid) || '' })
        .subscribe((response: ReturnStatusRequest) => {
          if (response.hasError) {
            this.toasterService.init({
              type: TOASTER_TYPE.DANGER,
              content: response.message!,
            });
            return;
          }

          this.returnRequest$.next(response);
        }),
    );
  }

  exportDetailsOrder() {
    this.subscription.add(
      this.returnsService.exportDetailsOrder({ uid: decodeURIComponent(this.uid) || '' }).subscribe(response => {
        this.excelDownloadService.downloadBase64File(response);
      }),
    );
  }
}
